import React from "react";
import "./lokacija.css";

const Lokacija = () => {
  return (
    <div className="lok-wrapper">

      {/* BACKGROUND EFFECTS */}
      <div className="bg-effects">
        <div className="glow glow1"></div>
        <div className="glow glow2"></div>
        <div className="glow glow3"></div>

        {[...Array(25)].map((_, i) => (
          <span
            key={i}
            className="spark"
            style={{
              left: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 10}s`,
              animationDuration: `${6 + Math.random() * 10}s`,
            }}
          ></span>
        ))}
      </div>

      {/* HERO */}
      <section className="lok-hero">

        <div className="lok-overlay"></div>

        <div className="lok-content">

          <p className="lok-subtitle">
            GHOST ATTACK 2.0
          </p>

          <h1>
            PILA <span>ZAGORSKI</span>
            <br />
            BEVERLY HILLS
          </h1>

          <p className="lok-desc">
            Smještena među zelenim brežuljcima Hrvatskog zagorja,
            Pila je mjesto gdje se asfalt susreće s atmosferom.
            Vikend pun oktana, zvuka turbine, mirisa guma i
            nezaboravne auto scene.
          </p>

          <div className="lok-tags">
            <span>🔥 Auto Meet</span>
            <span>🎵 DJ & Night Vibes</span>
            <span>📸 Premium Spotovi</span>
            <span>🏁 Park za Vozače</span>
          </div>

        </div>
      </section>

      {/* INFO */}
      <section className="lok-info-grid">

        <div className="lok-card">
          <h2>📍 Lokacija</h2>

          <p>
            Pila nije samo destinacija — to je iskustvo.
            Poznata među ekipom kao “Zagorski Beverly Hills”,
            pruža savršen spoj prirode, ceste i event atmosfere.
          </p>
        </div>

        <div className="lok-card">
          <h2>🚗 Park za Vozače</h2>

          <p>
            Organiziran parking za sudionike i show car zonu.
            Dovoljno prostora za ekipu i chill zonu.
          </p>
        </div>

        <div className="lok-card">
          <h2>🌌 Night Atmosfera</h2>

          <p>
            Nakon zalaska sunca Pila postaje cyberpunk hotspot.
            Neon, glow efekti, dobra glazba i automobili pod
            zvijezdama.
          </p>
        </div>

      </section>

      {/* MAP */}
      <section className="map-section">

        <div className="map-header">
          <h2>🗺️ PRONAĐI NAS</h2>

          <p>
            Easy access • Parking • Auto zona • Food & Chill
          </p>
        </div>

        <div className="map-container">

          <iframe
            title="Pila Lokacija"
            src="https://www.google.com/maps?q=Pila,Hrvatska&output=embed"
            allowFullScreen=""
            loading="lazy"
          ></iframe>

        </div>

      </section>

    </div>
  );
};

export default Lokacija;